export default "__VITE_ASSET__1e757ae9__"